/** Newsletter double opt-in confirmation page.
 *  Hit when the user clicks the link in the confirmation email. */
import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import { T } from "@/lib/theme";

const C = T.dark;
const API_BASE = (process.env.REACT_APP_BACKEND_URL || "") + "/api";

export default function NewsletterConfirm() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const [state, setState] = useState({ loading: true, ok: false, msg: "" });

  useEffect(() => {
    const token = params.get("token");
    if (!token) {
      setState({ loading: false, ok: false, msg: "No confirmation token in URL." });
      return;
    }
    axios.get(`${API_BASE}/free/newsletter/confirm`, { params: { token } })
      .then((r) => setState({ loading: false, ok: true, msg: r.data.message || "Confirmed!" }))
      .catch((e) => setState({ loading: false, ok: false,
        msg: e.response?.data?.detail || "Confirmation failed. The link may have expired." }));
  }, [params]);

  return (
    <div data-testid="newsletter-confirm-page" style={{ background: C.bg, minHeight: "100vh",
      color: C.text, fontFamily: "'Inter',sans-serif", display: "flex", alignItems: "center", justifyContent: "center", padding: 24 }}>
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@700;800&display=swap'); body{margin:0;background:${C.bg}}`}</style>
      <div style={{ background: C.surface, border: `1px solid ${C.border}`, borderRadius: 14,
        padding: 36, maxWidth: 460, width: "100%", textAlign: "center" }}>
        {state.loading ? (
          <>
            <div style={{ color: C.muted, fontSize: 14 }}>Confirming…</div>
          </>
        ) : state.ok ? (
          <>
            <div style={{ fontSize: 56, marginBottom: 18 }}>🎉</div>
            <h1 style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 28, fontWeight: 800, margin: "0 0 12px", letterSpacing: "-0.02em" }}>You're in.</h1>
            <p data-testid="confirm-msg" style={{ color: C.muted, fontSize: 14, lineHeight: 1.6, margin: "0 0 28px" }}>{state.msg}</p>
            <button data-testid="confirm-listen-btn" onClick={() => nav("/listen")}
              style={{ background: T.greenAccent, color: "#fff", border: "none", padding: "12px 28px",
                borderRadius: 8, fontSize: 14, fontWeight: 700, cursor: "pointer" }}>
              Listen to live radio now →
            </button>
          </>
        ) : (
          <>
            <div style={{ fontSize: 56, marginBottom: 18 }}>⚠️</div>
            <h1 style={{ fontFamily: "'Space Grotesk',sans-serif", fontSize: 24, fontWeight: 800, margin: "0 0 12px" }}>Couldn't confirm</h1>
            <p data-testid="confirm-msg" style={{ color: C.muted, fontSize: 14, lineHeight: 1.6, margin: "0 0 28px" }}>{state.msg}</p>
            <button data-testid="confirm-retry" onClick={() => nav("/listen")}
              style={{ background: "transparent", color: C.text, border: `1px solid ${C.border}`,
                padding: "10px 22px", borderRadius: 8, fontSize: 13, fontWeight: 600, cursor: "pointer" }}>
              Subscribe again
            </button>
          </>
        )}
      </div>
    </div>
  );
}
